import './home.scss';

import React, { useEffect, useState } from 'react';
import { Card } from 'primereact/card';
import { Badge } from 'primereact/badge';
import { Avatar } from 'primereact/avatar';
import { Divider } from 'primereact/divider';
import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';

export const BirthdayComponent = data => {
  const [daysInfo, setDaysInfo] = useState([]);
  const op = React.useRef(null);

  useEffect(() => {
    const personData = data?.data?.days;

    const today = new Date();

    const next7Days = Array.from({ length: 7 }, (_, i) => {
      const date = new Date();
      date.setDate(today.getDate() + i);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    });
    const allDaysInfo = next7Days.map(date => {
      const birthdaysToday = personData ? personData.filter(person => person.birthday && person.day.includes(date.slice(5))) : [];

      const namedaysToday = personData ? personData?.filter(person => !person.birthday && person.day.includes(date.slice(5))) : [];

      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
      const day = String(today.getDate()).padStart(2, '0');

      return {
        date,
        birthdays: birthdaysToday,
        namedays: namedaysToday,
        isToday: date === `${year}-${month}-${day}`,
        isEmpty: birthdaysToday.length === 0 && namedaysToday.length === 0,
      };
    });

    setDaysInfo(allDaysInfo);
  }, [data]);

  // Format date to display
  const formatDate = dateString => {
    const date = new Date(dateString);
    return date.toLocaleDateString('sk-SK', { month: 'long', day: 'numeric' });
  };

  // Get abbreviated person type
  const getPersonType = type => {
    return type === 'c' ? 'K' : 'P';
  };

  // Count total celebrations
  const totalCelebrations = daysInfo.reduce((total, day) => total + day.birthdays.length + day.namedays.length, 0);

  return (
    <Card className="shadow-2 p-0" style={{ width: '100%' }}>
      <div className="flex align-items-center justify-content-between mb-2">
        <h3 className="m-0">Narodeniny/Meniny</h3>
        <Badge value={totalCelebrations} severity="info" />
      </div>

      <div className="max-h-16rem overflow-auto">
        {daysInfo.map((day, index) => (
          <div key={day.date} className="mb-2">
            <div className="flex align-items-center" style={{ marginTop: '10px', marginBottom: '10px' }}>
              <span className={`font-bold ${day.isToday ? 'text-primary' : ''}`}>
                {formatDate(day.date)} {day.isToday && '(Dnes)'}
              </span>
            </div>

            <div className="pl-2">
              {day.isEmpty ? (
                <div className="py-1 text-500 text-sm italic">Žiadne výročia</div>
              ) : (
                <>
                  {day.birthdays.map(person => (
                    <div key={`bd-${person.id}`} className="flex align-items-center py-1">
                      <Avatar
                        label={getPersonType(person.type)}
                        size="normal"
                        style={{
                          backgroundColor: person.type === 'c' ? '#2196F3' : '#4CAF50',
                          color: '#ffffff',
                        }}
                        shape="circle"
                      />
                      <span className="ml-2">{person.name}</span>
                      <Badge value="Narodeniny" severity="info" className="ml-auto" />
                    </div>
                  ))}

                  {day.namedays.map(person => (
                    <div key={`nd-${person.id}`} className="flex align-items-center py-1">
                      <Avatar
                        label={getPersonType(person.type)}
                        size="normal"
                        style={{
                          backgroundColor: person.type === 'c' ? '#2196F3' : '#4CAF50',
                          color: '#ffffff',
                        }}
                        shape="circle"
                      />
                      <span className="ml-2">{person.name}</span>
                      <Badge value="Meniny" severity="warning" className="ml-auto" />
                    </div>
                  ))}
                </>
              )}
            </div>

            {index < daysInfo.length - 1 && <Divider className="my-2" />}
          </div>
        ))}
      </div>

      <div className="pt-2 flex justify-content-between">
        <Button label="Legenda" icon="pi pi-info-circle" className="p-button-text p-button-sm" onClick={e => op.current.toggle(e)} />
      </div>

      <OverlayPanel ref={op}>
        <div className="p-2">
          {/*<div className="mb-2">*/}
          {/*  <Badge value="N" severity="info" /> - Narodeniny*/}
          {/*</div>*/}
          {/*<div className="mb-2">*/}
          {/*  <Badge value="M" severity="warning" /> - Meniny*/}
          {/*</div>*/}
          <div className="mb-2">
            <Avatar label="K" size="normal" style={{ backgroundColor: '#2196F3', color: '#ffffff' }} /> - Klient
          </div>
          <div>
            <Avatar label="P" size="normal" style={{ backgroundColor: '#4CAF50', color: '#ffffff' }} /> - Poradca
          </div>
        </div>
      </OverlayPanel>
    </Card>
  );
};

export default BirthdayComponent;
